// extracted by mini-css-extract-plugin
module.exports = {"text":"Question_text__EMR4t","helpText":"Question_helpText__3FvBG","container":"Question_container__1Y3QS"};